/**
 * Determines if the current site is the Human/Voight site
 * @returns true if the origin includes "human" or "voight", false otherwise
 */
export function isHumanSite(): boolean {
  return typeof window !== "undefined" &&
         (window.location.origin.includes("human") || window.location.origin.includes("voight"));
}
